import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import UserControl from "../../form/partner/user";
import {EditorField as Editor} from "../../form/editor/editor";
import Select from "../../form/Select";
import Figures from "../../form/Figures";
import UrlEditor from "../urlEditor";
import UrlField from "../../form/UrlField";
import PriorityField from "../../form/PriorityField";

class authorForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-3 col-sm-push-9">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-2 col-sm-pull-3">
                        <UserControl
                            value={this.props.values}
                            fields={{"lastname": {parent: true}}}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-2 col-sm-pull-3">
                        <UserControl
                            value={this.props.values}
                            fields={{"firstname": {parent: true}}}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-3 col-sm-pull-3">
                        <UserControl
                            value={this.props.values}
                            fields={{"alias": {parent: true}}}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-2 col-sm-pull-3">
                        <Select
                            objectValue={true}
                            name="nationality"
                            value={this.props.values.nationality}
                            labelKey="nationality"
                            component="nationality"
                            storeType="local"
                            saveChanges={this.props.setFieldValue}
                            label="Nemzetiség"
                            {...this.props.getFieldProps("nationality")}
                        />
                    </div>
                </div>
                {this.props.componentConfig.fielddefs.url &&
                <UrlField {...this.props}/>}
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Figures name="images" label="Képek" component="person" componentId={this.props.values[this.props.componentConfig.idfield]} />
                    </div>
                </div>
                {/*<div className="row form-row">
                    <div className="col-md-12">
                        <TextArea {...this.props.getFieldProps("description")} name="description"
                                  value={this.props.values.description || ''} label="Leírás"
                                  saveChanges={this.props.setFieldValue}/>
                    </div>
                </div>*/}
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Editor {...this.props.getFieldProps("description")} name="description" component={this.props.componentConfig.componentname} componentId={this.props.values[this.props.componentConfig.idfield]} value={this.props.values.description || ''} label="Leírás" height="200px" saveChanges={ this.props.setFieldValue }/>
                    </div>
                </div>
                {this.props.componentConfig.fielddefs.order && <div className="row form-row">
                    <div className="col-sm-12">
                        {/*<CheckBox name="order" value={this.props.values.order} label="Megjelenik a főoldalon" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("order")}/>*/}
                        <Select {...this.props.getFieldProps("order")} objectValue={false} name="order" options={[{label: "Extra kiemelt", value: 2},{label: "Kiemelt", value: 1},{label: "Nincs kiemelve", value: 0}]} labelKey="label" valueKey="value" storeType="local" value={ this.props.values.order } saveChanges={ this.props.setFieldValue } label="Kiemelés" />
                    </div>
                </div>}
                {this.props.componentConfig.fielddefs.priority &&
                <PriorityField {...this.props}/>}
            </form>
        );
    }
}

export default createForm(authorForm);
